import { render, staticRenderFns } from "./serviceProviderView.vue?vue&type=template&id=6108eaf4&scoped=true&"
import script from "./serviceProviderView.vue?vue&type=script&lang=js&"
export * from "./serviceProviderView.vue?vue&type=script&lang=js&"
import style0 from "./serviceProviderView.vue?vue&type=style&index=0&id=6108eaf4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6108eaf4",
  null
  
)

export default component.exports